import { render, staticRenderFns } from "./messageSheet.vue?vue&type=template&id=378fd73d&scoped=true&"
import script from "./messageSheet.vue?vue&type=script&lang=js&"
export * from "./messageSheet.vue?vue&type=script&lang=js&"
import style0 from "./messageSheet.vue?vue&type=style&index=0&id=378fd73d&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378fd73d",
  null
  
)

export default component.exports